module.exports = __webpack_public_path__ + "static/img/ground.3fc42b1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ground.png
// module id = Zr/6
// module chunks = 167